import { Loader } from '@googlemaps/js-api-loader';

/**
 * Single shared Google Maps loader.
 *
 * `@googlemaps/js-api-loader` is a SINGLETON keyed by script id, and it throws
 * "Loader must not be called again with different options" if instantiated a
 * second time with different options. That happened when navigating client-side
 * between pages whose components created the loader with mismatched apiKey /
 * libraries / mapIds (e.g. NearbyFuelStations used apiKey:'' + ['places'] while
 * GoogleMapComponent used the real key + ['places','marker'] + mapIds), which
 * white-screened the route view.
 *
 * EVERY Google Maps consumer must go through this so the options are identical.
 */
const apiKey =
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || 'AIzaSyAd6J-M2idmQ_dBi3tfD8CGPws_cpYvDEM';
const mapId = process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID || 'f1f81d2941d6d32e';

let loader: Loader | null = null;

export function getGoogleMapsLoader(): Loader {
  if (!loader) {
    loader = new Loader({
      apiKey,
      version: 'weekly',
      // Superset of everything any consumer needs, so options never diverge.
      //
      // 'places' was dropped when LocationAutocomplete moved to /api/geocode —
      // nothing in client-app references google.maps.places any more. Keeping it
      // was not free: this key's API restrictions exclude Places, so requesting
      // the library logged ApiTargetBlockedMapError on every page with a map and
      // pulled places_impl.js + places.js down for nothing. Re-adding it means
      // re-enabling Places on the key, and paying for it.
      libraries: ['marker'],
      mapIds: [mapId],
    });
  }
  return loader;
}
